import { WebApiRequest, HTTP_GET, HTTP_PUT } from "tools/webservice";

const endpoint = (controlIdNumber, typeCode) => `/ETA/${controlIdNumber}/${typeCode}`;

export const TYPE_CODE_APPRAISER_DELIVERY = "AppraiserDelivery";
export const TYPE_CODE_FIELD_INSPECTION = "FieldInspection";

export const getETA = (controlIdNumber, typeCode, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: endpoint(controlIdNumber, typeCode),
  successCallback,
  errorCallback,
  mountedRef
});

export const updateETA = (controlIdNumber, typeCode, ETA, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  payload: {
    ETA
  },
  endpoint: endpoint(controlIdNumber, typeCode),
  successCallback,
  mountedRef
});
